import React from "react";

const Contact = () => (
  <div className='contact'>
    <h4> Contact Me</h4>
    <p>I'd be happy to hear from you!</p>
    <p>
      Drop me a line at <a href='mailto:mail@adamwoolf.com'>mail@adamwoolf.com</a>
    </p>
  </div>
);

export default Contact;
